import React, { Component } from 'react';
import { Tabs } from 'antd';
import OverView from './OverView';
import Contribute from './Contribute';
import Talent from './Talent';
import Develop from './Develop';
import Lose from './Lose';
import UserSider from '../UserSider';

const { TabPane } = Tabs;

class TeamManageEvaluate extends Component {
    state = {
        panes: [{
            title: '人员主管信息总览',
            key: 'overView',
            content: null,
        }, {
            title: '团队贡献度',
            key: 'contribute',
            content: null,
        }, {
            title: '培养人才梯队和输送人才',
            key: 'talent',
            content: null,
        }, {
            title: '新医院或新科室开发',
            key: 'develop',
            content: null,
        }, {
            title: '医院科室或项目丢失',
            key: 'lose',
            content: null,
        }],
        activeKey: 'overView',
    }

    componentDidMount() {
        this.updatePanes();
    }

    updatePanes = () => {
        const { panes, activeKey } = this.state;
        let RenderContent = null;
        if (activeKey == 'overView') {
            RenderContent = OverView;
        } else if (activeKey == 'contribute') {
            RenderContent = Contribute;
        } else if (activeKey == 'talent') {
            RenderContent = Talent;
        } else if (activeKey == 'develop') {
            RenderContent = Develop;
        } else if (activeKey == 'lose') {
            RenderContent = Lose;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey }, () => {
            this.updatePanes();
        });
    }

    render() {
        const { panes, activeKey } = this.state;
        return (
            <div className="content pmInfo">
                <UserSider selectKey='teamManageEvaluate' openKeys={['sub3']}/>
                <div className="main">
                    <div className="main-content">
                        <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                            {panes.map(pane => <TabPane tab={pane.title} key={pane.key}>{pane.content}</TabPane>)}
                        </Tabs>
                    </div>
                </div>
            </div>
        );
    }
}

export default TeamManageEvaluate;


// WEBPACK FOOTER //
// ./src/components/user/teamManageEvaluate/index.js